import { createStandardAction } from 'typesafe-actions';

export interface SignOutPayload {
  path?: string;
  includeReturnUrl?: boolean;
}

const signOut = createStandardAction('signOut')<SignOutPayload>();

export default signOut;
